import { type SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  d: string;
  className?: string;
  size?: number;
}

const Icon = ({ d, size = 24, className = "", ...props }: IconProps) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      className={className}
      height={size}
      width={size}
      fill="currentColor"
    >
      <path d={d} />
    </svg>
  );
};

export default Icon;
